import { nanoid } from 'nanoid'
import { type ActionItem, toastStore } from 'shared/ui'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { logger } from 'shared/lib'
import { type ICallingListResponse } from 'entities/AICalling/api/types'
import { AiCallingApi } from 'entities/AICalling/api/aiCallingApi'
import { checkUsageAgent } from 'pages/chatbot/pages/calling/actions/checkUsageAgent/checkUsageAgent'

export const deleteAction = (item: ICallingListResponse, onSuccess?: () => void): ActionItem => {
  return {
    text: 'Delete',
    icon: 'delete',
    onAction: async () => {
      try {
        const isUsage = await checkUsageAgent(item.id, 'delete')
        if (isUsage) return
        const id = nanoid()
        modalStore.addModal({
          id,
          type: ModalTypeList.ALERT,
          title: 'Delete AI Agent?',
          desc: 'This action cannot be undone',
          primaryAction: {
            text: 'Delete',
            onAction: async () => {
              try {
                await AiCallingApi.delete(item.id)

                onSuccess && onSuccess()
                modalStore.closeModal(id)
                toastStore.add({
                  type: 'success',
                  title: 'AI Agent deleted',
                })
              } catch (e) {
                logger.error(e)
              }
            },
          },
          secondaryAction: {
            text: 'Cancel',
            onAction: () => {
              modalStore.closeModal(id)
            },
          },
        })
      } catch (e) {
        toastStore.add({
          type: 'error',
          title: 'Something went wrong, try again!',
        })
        logger.error(e)
      }
    },
  }
}
